module.exports = __webpack_public_path__ + "static/media/service.9084f331.jpg";